import React from 'react';
import { useForm } from 'react-hook-form';
import { useAuth } from '../../Context/AuthContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Logo from '../../assets/images/logo.svg'
import Envelop from '../../assets/images/envelop.png'
import Lock from '../../assets/images/lock.png'
import { useNavigate } from 'react-router-dom';

export default function Signup() {
    const form = useForm();
    const { signup } = useAuth();

    const {
        register,
        handleSubmit,
        watch,
        formState: { errors }
    } = form;

    const password = watch('password', '');
    const navigate = useNavigate();


    const onSubmit = async (data) => {
        const { email, password, firstname, lastname } = data;

        console.log('Data to send to signup:', { email, password, firstname, lastname });
        localStorage.setItem('email', email);
        localStorage.setItem('password', password);


        const result = await signup({ email, password, first_name: firstname, last_name: lastname });
        if (result) {
            navigate('/Otp?from=signup');
        }

        form.reset()

    };




    return (
        <div className="Login-container">
            <div className="component-holder">
                <div className="filter">
                    <div className="header-holder">
                        <img className='logo' src={Logo} alt="logo" />
                        <p>Intelligent Heritage Explorer</p>
                    </div>
                    <div className='login-form'>
                        <form className='form-signup-holder' onSubmit={handleSubmit(onSubmit)} noValidate>
                            <div className='input-holder-name'>
                                <div className='first-name'>
                                    <label>First Name</label>
                                    <div>
                                        <input
                                            type="text"
                                            placeholder="John"
                                            {...register('firstname', {
                                                required: true,
                                                minLength: 3
                                            })}
                                        />
                                        {errors.firstname && errors.firstname.type === "required" && (
                                            <p className="errorMsg">First name is required.</p>
                                        )}
                                        {errors.firstname && errors.firstname.type === "minLength" && (
                                            <p className="errorMsg">minimun length 3 characters.</p>
                                        )}

                                    </div>

                                </div>

                                <div className='last-name'>
                                    <label>Last Name</label>
                                    <div>
                                        <input
                                            type="text"
                                            placeholder="wick"
                                            {...register('lastname', {
                                                required: true,
                                                minLength: 3
                                            })}
                                        />
                                        {errors.lastname && errors.lastname.type === "required" && (
                                            <p className="errorMsg">Last name is required.</p>
                                        )}
                                        {errors.lastname && errors.lastname.type === "minLength" && (
                                            <p className="errorMsg">minimun length 3 characters.</p>
                                        )}

                                    </div>

                                </div>

                            </div>
                            <div className='input-holder-email'>
                                <label>Email address</label>
                                <div className='input-with-icon'>
                                    <input
                                        type="email"
                                        placeholder="Alex@email.com"
                                        {...register('email', {
                                            required: true,
                                            pattern: /^[a-zA-Z0-9_.+-]+@(gmail\.com|yahoo\.com)$/
                                        })}
                                    />
                                    <img
                                        src={Envelop}
                                        alt="Envelope"
                                        className="icon"
                                    />
                                    {errors.email && errors.email.type === "required" && (
                                        <p className="errorMsg">Email is required.</p>
                                    )}
                                    {errors.email && errors.email.type === "pattern" && (
                                        <p className="errorMsg">Email is not valid.</p>
                                    )}

                                </div>

                            </div>
                            <div className='input-holder-password'>
                                <label>Password</label>
                                <div className='input-with-icon'>
                                    <input
                                        type="password"
                                        placeholder="Enter your password"
                                        {...register("password", {
                                            required: true,
                                            validate: {
                                                checkLength: (value) => value.length >= 6,
                                                matchPattern: (value) =>
                                                    /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#_-|$*])/.test(
                                                        value
                                                    )
                                            }
                                        })}
                                    />
                                    <img
                                        src={Lock}
                                        alt="Lock"
                                        className="icon"
                                    />
                                    {errors.password && errors.password.type === "required" && (
                                        <p className="errorMsg">Password is required.</p>
                                    )}
                                    {errors.password && errors.password.type === "checkLength" && (
                                        <p className="errorMsg">
                                            Password should be at-least 10 characters.
                                        </p>
                                    )}
                                    {errors.password && errors.password.type === "matchPattern" && (
                                        <p className="errorMsg">
                                            password must contain at least capital char and special char.
                                        </p>
                                    )}

                                </div>
                            </div>
                            <div className='input-holder-password'>
                                <label>Confirm Password</label>
                                <div className='input-with-icon'>
                                    <input
                                        type="password"
                                        placeholder="Enter your password"
                                        {...register("confirmPassword", {
                                            required: true,
                                            validate: value => value === password || "Passwords do not match"
                                        })}
                                    />
                                    <img
                                        src={Lock}
                                        alt="Lock"
                                        className="icon"
                                    />
                                    {errors.confirmPassword && errors.confirmPassword.type === "required" && (
                                        <p className="errorMsg">Confirm password is required.</p>
                                    )}
                                    {errors.confirmPassword && errors.confirmPassword.type === "validate" && (
                                        <p className="errorMsg">Passwords do not match.</p>
                                    )}


                                </div>
                            </div>


                            <button className='login-button' type="submit" >Sign Up</button>
                        </form>


                    </div>

                </div>

            </div>
            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={true}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored" />
        </div>
    )
}